// extracted by mini-css-extract-plugin
module.exports = {"projectContainer":"ProjectContainer_projectContainer__2qkGE","dark":"ProjectContainer_dark__70VCA"};